import { getRoundingMethodLabel } from "pages/CalculationRules/CalculationRules.Precision"

export const RoundingStrategyCell = ({ value }: { value: any }) => {
    return <span>{getRoundingMethodLabel(value || "")}</span>
}
